<template>
  <div class="message-separator">
    <v-divider />
    <span class="message-date">
      {{ formattedDate }}
    </span>
    <v-divider />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppChatMessageSeparator',
  props: {
    date: {
      type: String,
      default: () => dayjs().toISOString(),
    },
  },
  computed: {
    formattedDate () {
      const inputDate = dayjs(this.date)
      const today = dayjs()
      const yesterday = dayjs().subtract(1, 'day')

      if (inputDate.isSame(today, 'day')) {
        return this.$t('common.today')
      }

      if (inputDate.isSame(yesterday, 'day')) {
        return this.$t('common.yesterday')
      }

      return inputDate.format('dddd DD MMMM')
    },
  },
})
</script>

<style scoped>
.message-separator {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  column-gap: 12px;

  .message-date {
    font-size: 12px;
    font-weight: 700;
    text-transform: capitalize;
    line-height: 16px;
    color: rgb(var(--v-theme-grey-darken-2));
    opacity: .65;
  }
}
</style>
